import React from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import NetProfitGraph from "../../../../components/PagesComponents/Financial/Accountant/Dashboard/NetProfitGraph.components";
import HorizontalBarGraph from "../../../../components/PagesComponents/Financial/Accountant/Dashboard/HorizontalBarGraph.components";
import CashflowDataPieChart from "../../../../components/PagesComponents/Financial/Accountant/Dashboard/CashFlowDataPiChart.component";
import NumberCard from "../../../../components/Universal/NumberCard.component";
import "../../../../styles/Pages/Financial/Accountant/Dashboard/Dashboard.style.css";

const Body = ({
  lineChartData,
  horizontalBarChartData,
  cashInFlowPieChartData,
  cashOutFlowPieChartData,
  cashFlowData,
}) => {
  return (
    <section className="accountentDashboard">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <PageHeader
        title={"Dashboard"}
        renderCustomElement={
          <button className="blueActionBtnLight toggleActionBtn">
            <input type="checkbox" />{" "}
            <span className="box">Know financial terms</span>
          </button>
        }
      />
      <div className="mainContainer">
        <div className="netProfitGraphContainer">
          <div className="apperanceGraph">
            <NetProfitGraph graphData={lineChartData} />
            <HorizontalBarGraph graphData={{ horizontalBarChartData }} />
          </div>
          <div className="cashflowContainer">
            <div className="cashflowData">
              <NumberCard NumberData={cashFlowData?.cashInFlow} />
              <NumberCard NumberData={cashFlowData?.cashOutFlow} />
            </div>
            <div className="pieChartAndOEDetailsContainer">
              <div className="cashflowDataPaiChart">
                <CashflowDataPieChart
                  chartData={cashInFlowPieChartData}
                  title={`Cash InFlow Contribution`}
                />
                <div
                  style={{
                    width: "4px",
                    height: "180px",
                    backgroundColor: "gray",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "100px",
                  }}
                ></div>
                <CashflowDataPieChart
                  chartData={cashOutFlowPieChartData}
                  title={`Cash OutFlow Contribution`}
                />
              </div>
              <div className="oeRatioContainer">
                <h1>
                  OE Ratio: <span style={{ color: "black" }}>40%</span>
                </h1>
                <span className="up color-greenColor">+3.4%</span>
                <span className="note color-redColor">Bad For Business</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
